import { CarouselBeta, CarouselSlideBeta, H3 } from '@zooplus/ui-components';
import { useTranslation } from '../../hooks/use-translations';
import React from 'react';
import styles from './Reviews.module.scss';
import { Review } from './review';
import { EmblaOptionsType } from 'embla-carousel';
import { range } from '../../utils';

export type ReviewsProps = {};

export const Reviews = ({}: ReviewsProps) => {
  const { t } = useTranslation();
  const options: EmblaOptionsType = {
    align: 'center',
    breakpoints: {
      '(min-width: 0px)': {
        align: 'center',
        slidesToScroll: 1,
      },
      '(min-width: 544px)': {
        align: 'start',
        slidesToScroll: 2,
      },
    },
    slidesToScroll: 1,
  };

  return (
    <section>
      <H3 className={styles.title}>{t('reviews.title')}</H3>
      <div className={styles.reviewsMobile}>
        <CarouselBeta
          id="reviews-carousel"
          nextButtonAriaLabel="next"
          previousButtonAriaLabel="previous"
          className={styles.carouselReviews}
          emblaOptions={options}
          gap={'12px'}>
          {range(1, 3).map((reviewNum) => (
            <CarouselSlideBeta key={`review-${reviewNum}`} className={styles.carouselItemReview}>
              <Review reviewNumber={reviewNum} />
            </CarouselSlideBeta>
          ))}
        </CarouselBeta>
      </div>
      <div className={styles.reviewsOtherDevices}>
        {range(1, 3).map((reviewNum) => (
          <Review key={`review-${reviewNum}`} reviewNumber={reviewNum} />
        ))}
      </div>
    </section>
  );
};
